module.exports = __webpack_public_path__ + "img/happy_clients.d4c66b03.svg";